import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '../ui/Button';

export function Header() {
  const location = useLocation();

  const navLinks = [
    { label: 'What We Run', to: '/what-we-run' },
    { label: 'Projects', to: '/projects' },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-primary/80 backdrop-blur-sm border-b border-border/50">
      <div className="container-full">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="text-foreground font-semibold tracking-tight">
            Bliu Interactive
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-small transition-colors duration-normal ${
                  location.pathname === link.to
                    ? 'text-foreground'
                    : 'text-muted hover:text-foreground'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <Button to="/brief" size="sm" variant="secondary">
            Submit a Brief
          </Button>
        </div>
      </div>
    </header>
  );
}

export default Header;
